var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('TopBar',{staticStyle:{"height":"6vh"}}),_c('main',{staticClass:"bg-white",staticStyle:{"min-height":"94vh"}},[_c('router-view',{staticClass:"h-full"})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }